import { BrandPageQueryObj } from "@faire/retailer-shared/search/BrandPageQueryObj";
import { SpacerValueOrKey } from "@faire/web--source/slate/spacing/getSpacing";
import { ResponsiveValues } from "@faire/web--source/slate/Theme/ResponsiveValues";
import { lazy } from "react";

import { ILeanBrandTileWithReview } from "@faire/retailer/components/LeanBrandTileRenderer/ILeanBrandTileWithReview";

export interface IProps {
  brands: ILeanBrandTileWithReview[];
  isFetching?: boolean;
  brandPageQueryParams?: BrandPageQueryObj | undefined;
  requestId?: string;
  className?: string;
  onClick?: (token: string) => void;
  onView?: () => void;
  ctaLink?: string;
  onCtaClick?: () => void;
  onTileView?: (brandToken: string) => void;
  /**
   * Override the default number of items per slide for desktop and above.
   */
  desktopAndAboveItemsPerSlide?: number;
  /**
   * Override the default gap between the title and the carousel.
   */
  belowTitleGap?: ResponsiveValues<SpacerValueOrKey>;
  /**
   * Override the default gap between the top of carousel and the top of title.
   */
  aboveTitleGap?: SpacerValueOrKey;
}

export const LazySearchCategoryCarousel = lazy(() =>
  import(
    /* webpackChunkName: "search-category-carousel" */ "./SearchCategoryCarousel"
  ).then((m) => ({ default: m.SearchCategoryCarousel }))
);
